module.exports = __webpack_public_path__ + "static/media/no-company-picture.6dd62f98.svg";